export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="no-print sticky top-0 z-20 bg-slate-100/90 backdrop-blur border-b border-slate-200 px-6 lg:px-8 py-4 flex items-center justify-between">
      <div>
        <h1 className="font-head text-2xl font-bold text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{actions}</div>
    </div>
  );
}
